import React, { useState } from 'react';
import { CheckboxActive, CheckboxInactive, CopyIcon, InfoIcon } from '../utils/Icons';
import Space from './Space';
import Label from './Label';



const Checkbox = React.forwardRef((props, ref) => {

    const { onChange = () => { }, onEnter = () => { }, value = false, className = "", edit = true, disabled = false } = props;

    let _class = (value) ? "ui-checkbox active" : "ui-checkbox inactive";

    const handleKeyDown = (e) => {

        if (!edit) {
            return;
        }

        if (e.key === " " || e.key === "Spacebar") {
            e.stopPropagation();
            e.preventDefault();
            onChange(!value);
        }
        if (e.key === "Enter") {
            e.stopPropagation();
            e.preventDefault();
            onEnter(!value);
        }
    };

    if (className) {
        _class += " " + className;
    }

    if(disabled){
         _class += " " + "dim";
    }

    return (
        <div tabIndex={-1} ref={ref} onKeyDown={handleKeyDown} onClick={(e) => { e.stopPropagation(); e.preventDefault(); if (edit) { onChange(!value) } }} className={_class} style={{ cursor: 'pointer', display: 'inline-block', "pointerEvents" : (disabled) ? "none" :"auto", "opacity" : (disabled) ? "0.4" : "1" }}>
            <Space>{value ? <CheckboxActive /> : <CheckboxInactive />}<>{props.children}</></Space>
        </div>
    );
})

export default Checkbox;